import { LOGO } from "../content";

// Decorative: the text next to it carries the name.
export function Logo({ className = "" }: { className?: string }) {
  return (
    <span className={`block shrink-0 overflow-hidden rounded-full ring-1 ring-white/15 ${className}`}>
      <img src={LOGO} alt="" width={625} height={625} decoding="async" className="h-full w-full object-cover" />
    </span>
  );
}
